import {
  BadgePercent,
  Banknote,
  Building2,
  ClipboardList,
  FileText,
  Briefcase,
  CalendarDays,
  CalendarRange,
  GraduationCap,
  Home,
  Handshake,
  Package,
  Presentation,
  BookOpen,
  Receipt,
  Scale,
  School,
  ShieldCheck,
  Sparkles,
  Stethoscope,
  Store,
  Megaphone,
  Stamp,
  Truck,
  University,
  Users,
  Wallet,
  Warehouse,
} from "lucide-react";

export type ServiceIconKey =
  | "auto"
  | "store"
  | "shield-check"
  | "stethoscope"
  | "graduation-cap"
  | "book-open"
  | "presentation"
  | "school"
  | "university"
  | "users"
  | "handshake"
  | "scale"
  | "file-text"
  | "clipboard-list"
  | "stamp"
  | "receipt"
  | "banknote"
  | "badge-percent"
  | "briefcase"
  | "building-2"
  | "home"
  | "calendar-range"
  | "package"
  | "truck"
  | "warehouse"
  | "calendar-days"
  | "megaphone"
  | "wallet";

type ServiceIconOption = {
  key: ServiceIconKey;
  label: string;
  Icon: typeof Store;
};

export const SERVICE_ICON_OPTIONS: ServiceIconOption[] = [
  { key: "auto", label: "Auto", Icon: Sparkles },
  { key: "store", label: "Comercio", Icon: Store },
  { key: "shield-check", label: "Seguridad", Icon: ShieldCheck },
  { key: "stethoscope", label: "Salud", Icon: Stethoscope },
  { key: "graduation-cap", label: "Formacion", Icon: GraduationCap },
  { key: "book-open", label: "Educacion", Icon: BookOpen },
  { key: "presentation", label: "Capacitacion", Icon: Presentation },
  { key: "school", label: "Escuela", Icon: School },
  { key: "university", label: "Universidad", Icon: University },
  { key: "users", label: "Vinculacion", Icon: Users },
  { key: "handshake", label: "Convenios", Icon: Handshake },
  { key: "scale", label: "Legal", Icon: Scale },
  { key: "file-text", label: "Documentos", Icon: FileText },
  { key: "clipboard-list", label: "Tramites", Icon: ClipboardList },
  { key: "stamp", label: "Sellos", Icon: Stamp },
  { key: "receipt", label: "Recibos", Icon: Receipt },
  { key: "banknote", label: "Economico", Icon: Banknote },
  { key: "badge-percent", label: "Promocion", Icon: BadgePercent },
  { key: "briefcase", label: "Gestion", Icon: Briefcase },
  { key: "building-2", label: "Institucion", Icon: Building2 },
  { key: "home", label: "Espacios", Icon: Home },
  { key: "calendar-range", label: "Agenda", Icon: CalendarRange },
  { key: "package", label: "Logistica", Icon: Package },
  { key: "calendar-days", label: "Eventos", Icon: CalendarDays },
  { key: "truck", label: "Envios", Icon: Truck },
  { key: "warehouse", label: "Deposito", Icon: Warehouse },
  { key: "megaphone", label: "Marketing", Icon: Megaphone },
  { key: "wallet", label: "Finanzas", Icon: Wallet },
];

const SERVICE_ICON_MAP: Record<ServiceIconKey, typeof Store> = {
  auto: Sparkles,
  store: Store,
  "shield-check": ShieldCheck,
  stethoscope: Stethoscope,
  "graduation-cap": GraduationCap,
  "book-open": BookOpen,
  presentation: Presentation,
  school: School,
  university: University,
  users: Users,
  handshake: Handshake,
  scale: Scale,
  "file-text": FileText,
  "clipboard-list": ClipboardList,
  stamp: Stamp,
  receipt: Receipt,
  banknote: Banknote,
  "badge-percent": BadgePercent,
  briefcase: Briefcase,
  "building-2": Building2,
  home: Home,
  "calendar-range": CalendarRange,
  package: Package,
  "calendar-days": CalendarDays,
  truck: Truck,
  warehouse: Warehouse,
  megaphone: Megaphone,
  wallet: Wallet,
};

export const getServiceIcon = (icon: unknown, category?: string) => {
  if (typeof icon === "function") {
    return icon as typeof Store;
  }
  if (typeof icon === "string" && icon in SERVICE_ICON_MAP && icon !== "auto") {
    return SERVICE_ICON_MAP[icon as ServiceIconKey];
  }
  const cat = category?.toLowerCase() || "";
  if (cat.includes("salud")) return Stethoscope;
  if (cat.includes("legal")) return Scale;
  if (cat.includes("educ")) return GraduationCap;
  if (cat.includes("beca")) return BookOpen;
  if (cat.includes("vincul")) return Users;
  if (cat.includes("promoc")) return BadgePercent;
  if (cat.includes("tramite")) return ClipboardList;
  if (cat.includes("admin")) return Briefcase;
  if (cat.includes("econom")) return Banknote;
  if (cat.includes("seguridad")) return ShieldCheck;
  if (cat.includes("finanza") || cat.includes("credito")) return Wallet;
  if (cat.includes("logistica") || cat.includes("envio")) return Package;
  if (cat.includes("deposito") || cat.includes("almacen")) return Warehouse;
  if (cat.includes("evento") || cat.includes("feria")) return CalendarDays;
  if (cat.includes("convenio")) return Handshake;
  if (cat.includes("institu") || cat.includes("camar")) return Building2;
  if (cat.includes("gestion")) return Briefcase;
  if (cat.includes("espacio") || cat.includes("alquiler") || cat.includes("sala")) return Building2;
  return Store;
};
